import { IsString, MaxLength } from "class-validator";

export class PositionSearchDTO {
    
    @IsString()
    @MaxLength(50)
    name: string;

}
